import { useDataTransactions } from "./useDataTransactions";

export default useDataTransactions;
